import './Templates.scss'
import Select from 'react-select';
import {TemplateContext, UpdateTemplate} from "../../Contexts/TemplateProvider"
import { CategoryContext } from '../../Contexts/CategoryProvider';
import { useContext, useEffect, useState } from 'react';
import RGL, { WidthProvider } from "react-grid-layout";
import DashboardItem from '../../Components/DashboardItem/DashboardItem';
import Loading from '../../Components/Loading';
export default function Templates(){
  const { templateCategories,defaultCategories,loading,refreshTemplate} = useContext(TemplateContext);
  const [isLoading, setIsLoading] =useState(loading)
  const { Categories,refreshCategory } = useContext(CategoryContext);
  const [selectedCategories, setSelectedCategories] = useState(defaultCategories);
  const [value, setValue] = useState();
  const [options, setOptions] = useState([])
  const [children, setChildren] = useState([])
  const ReactGridLayout = WidthProvider(RGL);
  const [layout,setLayout] = useState()
  const updateTemplate = UpdateTemplate();
  useEffect(()=>{
    document.title = "Templates"
    refreshTemplate()
    refreshCategory()
  },[refreshTemplate,refreshCategory])
// Make an array that can be used for the Select tags
useEffect(() => {
  if(!loading){
    const a = []
    const selected = []
    Categories.forEach((category) => {
        a.push({value: category.categoryName, label: category.categoryName})
        if(templateCategories.filter((item) => item.categoryName === category.categoryName) != null){
          selected.push({value: category.categoryName, label: category.categoryName})
        }
    })
    setOptions(a)
    setSelectedCategories(defaultCategories)
  }
},[loading,Categories,templateCategories,defaultCategories])

// When the categorie is changed -> set the current category and set the children to the MVO goals
function ChangeCategory(v){
  setIsLoading(true)
  setValue(v)
  const currentCategory = Categories.filter((item) => item.categoryName === v.value)
  if(currentCategory[0] != null){
    const a = getAllMvosFromSdgs(currentCategory)
    setChildren(a.map((mvo) => <div key={mvo.MVOgoalId}><DashboardItem data={mvo}/></div>))
  }
  
  if(localStorage.getItem(v.value) != null){
    setLayout(JSON.parse(localStorage.getItem(v.value)))

  }
  setSelectedCategories(defaultCategories)
  setTimeout(() => {
    setIsLoading(false) 
  }, 750); 
}

// This functions makes an array of all MVO goals
function getAllMvosFromSdgs(category){
  var list = []
  category[0].sdg.forEach((SDG) =>{
    if(SDG.mvogoal.length > 0)
      SDG.mvogoal.forEach(mvo =>list.push(mvo))
  })
  return list
}

//Save the layout to the database
function saveToDB(){
  var json = [];
  selectedCategories.forEach(cat => {
    const layout = localStorage.getItem(cat.value);
    json.push({name:cat.value,layout:layout})
  })
  updateTemplate(json,selectedCategories)
}

//OnLayoutchange function -> if something gets changed in the layout this is being runned
function onLayoutChange(layout){ 
  localStorage.setItem(value.value, JSON.stringify(layout))
  setLayout(layout)
  
}
  return (
      <div className='CategoriesContainer' required data-cy="categories">
        <div key={defaultCategories} className='toprow'> 
        {options.length > 0 && defaultCategories.length > -1 &&<Select
          isMulti
          closeMenuOnSelect={false}
          options={options}
          value={selectedCategories}
          className="SelectMenu"
          classNamePrefix="select"         
          onChange={(value)=> setSelectedCategories(value)}
          placeholder="Select Categories to show..."/>}
          {options.length>0&&<Select className='SelectMenu2' placeholder="Select Category..." classNamePrefix='select' options={selectedCategories} onChange={(v) => {ChangeCategory(v)}}/>}
          <button className='saveBtn' onClick={() => saveToDB()}>Save</button>
        </div>
        {isLoading === true && <Loading type="spin" color="#004C69"/>}
        {value && isLoading === false &&
            <ReactGridLayout
            className="layout"
            layout={layout}
            cols={20}
            measureBeforeMount={true}
            useCSSTransforms={false}
            rowHeight={33}
            onLayoutChange={(layout) => onLayoutChange(layout)}
          >
            {children}
          </ReactGridLayout>
        }
      </div>
  );
}